module.exports = __webpack_public_path__ + "static/media/logo-suma.31b67164.svg";